import { reportCommData } from '@tencent/pmd-report';

function getEventContent(childId, teamId, scheId, battleId, elementId, eventDuration) {
  const eventContent = {};
  if (childId) {
    eventContent.child_id = `${childId}`;
  }
  if (teamId) {
    eventContent.team_id = `${teamId}`;
  }
  if (scheId) {
    eventContent.sche_id = `${scheId}`;
  }
  if (battleId) {
    eventContent.battle_id = `${battleId}`;
  }
  if (elementId) {
    eventContent.element_id = `${elementId}`;
  }
  if (eventDuration) {
    eventContent.event_duration = `${eventDuration}`;
  }
  return eventContent;
}

/**
 * 点击上报
 * @param secondChannel 二级渠道
 * @param eventId 事件id
 * @param childId 子活动id
 * @param teamId 队伍id
 * @param scheId 赛程id
 * @param battleId 比赛id
 */
export function reportClick(secondChannel, eventId, childId, teamId, scheId, battleId, elementId) {
  const eventContent = getEventContent(childId, teamId, scheId, battleId, elementId);
  reportCommData({
    second_channel: secondChannel,
    event_id: eventId,
    ...eventContent,
  }, [1]);
}

/**
 * 曝光上报
 * @param secondChannel 二级渠道
 * @param childId 子活动id
 * @param teamId 队伍id
 * @param scheId 赛程id
 * @param battleId 比赛id
 * @param eventId 事件id
 */
export function reportPageExposure(secondChannel, childId, teamId, scheId, battleId, elementId, eventId = 'page_exposure') {
  const eventContent = getEventContent(childId, teamId, scheId, battleId, elementId);
  reportCommData({
    second_channel: secondChannel,
    event_id: eventId || 'page_exposure',
    ...eventContent,
  }, [1]);
}

/**
 * 时长上报
 * @param secondChannel 二级渠道
 * @param childId 子活动id
 * @param teamId 队伍id
 * @param scheId 赛程id
 * @param battleId 比赛id
 */
export function reportPageDuration(secondChannel, childId, teamId, scheId, battleId, elementId, eventDuration) {
  const eventContent = getEventContent(childId, teamId, scheId, battleId, elementId, eventDuration);
  reportCommData({
    second_channel: secondChannel,
    event_id: 'page_duration',
    ...eventContent,
  }, [1]);
}

/**
 * 自定义上报
 * @param secondChannel 二级渠道
 * @param eventId event_id
 * @param customData  自定义数据
 */
export function reportCustomData(secondChannel, eventId, customData) {
  reportCommData({
    second_channel: secondChannel,
    event_id: eventId,
    ...customData,
  }, [1]);
}
